import React, { useContext, useEffect } from 'react';

import Markup from '../../../../markup';
import BuilderContext from '../../../../builder/hooks/context';
import { trackBeforeUnload, trackSubStage } from '../../../../utils/Analytics';

function DesignCollar() {
  const { builder } = useContext(BuilderContext);


  useEffect(() => {
    trackSubStage('Design', 'Collar');
    trackBeforeUnload('Collar');
  }, []);

  return (
    <>
      <Markup.Screen.Design.Container checkCount={builder?.modelData?.surffaceList.length}>
        {builder?.modelData?.collarList?.map(item => <Markup.Screen.Design.ItemCollar
          key={item.id}
          active={builder.modelData.collar === item.id}
          onClick={() => builder.modelData.setCollar(item.id)}
          preview={item.preview}
          children={item.title}
          themeColor={builder.membersData.colorTheme}
        />)}
      </Markup.Screen.Design.Container>
    </>
  );
}

export default React.memo(DesignCollar);
